import { Navigate } from "react-router-dom";
import ModalLoadingFull from "../components/modals/ModalLoadingFull";
import LoginRedirect from "../pages/user/Login/LoginRedirect";
import MainLayout from "../components/layout/MainLayout";
import { findGetParameter } from "../components/utilities/UtilityFunctions";
import PostEditor from "../pages/cms/PostEditor";
import PostList from "../pages/cms/PostList";
import PageList from "../pages/cms/PageList";
import TagEditor from "../pages/cms/TagEditor";
import TagList from "../pages/cms/TagList";
import CMSAdmin from "../pages/cms/CMSAdmin";
import NotFound from "../pages/utility/NotFound";
import CMSRouter from "../cms/CMSRouter";
import News from "../pages/cms/News";
import { getEnvironmentVariable } from "../global/environmentVariables";
const SUPPORTS_CMS = getEnvironmentVariable("SUPPORTS_CMS") === "true";

export const cmsRoutes = (authContext, itemsMiddle, setItemsMiddle) => {
  const forceLoginParam = findGetParameter("forceLogin");

  if (!SUPPORTS_CMS) {
    return [];
  }

  return [
    {
      path: "cms",
      element:
        !authContext?.authState || authContext?.authState?.isLoading ? (
          <ModalLoadingFull />
        ) : authContext?.authState?.identity?.isAdmin !== true ? (
          <Navigate to="/access-denied" />
        ) : forceLoginParam?.toLowerCase() === "true" &&
          !authContext?.authState?.isAuthenticated ? (
          <LoginRedirect />
        ) : (
          <MainLayout
            cms
            authContext={authContext}
            itemsMiddle={itemsMiddle}
            setItemsMiddle={setItemsMiddle}
          />
        ),
      children: [
        {
          path: "post",
          element: <PostEditor />,
        },
        {
          path: "post/:postId",
          element: <PostEditor />,
        },
        {
          path: "my-posts",
          element: <PostList />,
        },
        {
          path: "my-pages",
          element: <PageList />,
        },
        {
          path: "tag",
          element: <TagEditor />,
        },
        {
          path: "new-tag",
          element: <TagEditor />,
        },
        {
          path: "tag/:tagId",
          element: <TagEditor />,
        },
        {
          path: "tag-list",
          element: <TagList />,
        },
        {
          path: "/cms/",
          element: <CMSAdmin />,
        },
      ],
    },
    {
      path: "news",
      element: authContext?.authState?.isLoading ? (
        <ModalLoadingFull />
      ) : forceLoginParam?.toLowerCase() === "true" &&
        !authContext?.authState?.isAuthenticated ? (
        <LoginRedirect />
      ) : (
        <MainLayout
          authContext={authContext}
          itemsMiddle={itemsMiddle}
          setItemsMiddle={setItemsMiddle}
        />
      ),
      children: [
        {
          path: "/news/",
          element: <News />,
        },
        {
          path: ":tag",
          element: <News />,
        },
      ],
    },
    {
      path: "pages/:pageId",
      element: <CMSRouter />,
    },
    { path: "pages", element: <NotFound /> },
  ];
};
